import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sbw-validation-summary-demo',
    templateUrl: './validation-summary-demo.component.html'
})
export class ValidationSummaryDemoComponent implements OnInit {
    public errors: string[] = ['demo error message', 'another demo error message']
    constructor() { }

    ngOnInit() {
    }

}
